import { IconLayerGray, IconLayers, IconPcLine, IconSecurity } from '@assets/images/icon';
import { IconComputer, IconGuarantee } from '@assets/images/main';
import { IconOsEdgeOff, IconOsEdgeOn, IconOsServerOff, IconOsServerOn, IconOsSwitchOff, IconOsSwitchOn } from '@assets/images/main/icon';
import {
  IconBlueCircle,
  IconBlueCycle,
  IconBlueDevelop,
  IconBlueFigure,
  IconBluePlus,
  IconBluePower,
  IconBlueScan,
  IconBlueShield,
} from '@assets/images/main/icon/blue';
import { osBanner, osDownloadD, osDownloadM, osDownloadT, osLogoDesktop, osLogoMobile, osLogoTablet } from '@assets/images/main/os/bannerImg';
import {
  OsSectionDesktop1,
  OsSectionTablet1,
  OsSectionMobile1,
  OsSectionDesktop2,
  OsSectionTablet2,
  OsSectionMobile2,
  OsSectionDesktop3,
  OsSectionTablet3,
  OsSectionMobile3,
  OsSectionDesktop4,
  OsSectionTablet4,
  OsSectionMobile4,
  OsSectionDesktop5,
  OsSectionTablet5,
  OsSectionMobile5,
  OsSectionDesktop6,
  OsSectionTablet6,
  OsSectionMobile6,
  OsSectionDesktop7,
  OsSectionTablet7,
  OsSectionMobile7,
  OsSectionDesktop8,
  OsSectionTablet8,
  OsSectionMobile8,
  OsSectionDesktop9,
  OsSectionTablet9,
  OsSectionMobile9,
  OsSectionDesktop10,
  OsSectionTablet10,
  OsSectionMobile10,
  OsSectionDesktop11,
  OsSectionTablet11,
  OsSectionMobile11,
  OsSectionDesktop12,
  OsSectionTablet12,
  OsSectionMobile12,
  OsSectionDesktop13,
  OsSectionTablet13,
  OsSectionMobile13,
  OsSectionDesktop14,
  OsSectionTablet14,
  OsSectionMobile14,
  OsSectionDesktop15,
  OsSectionTablet15,
  OsSectionMobile15,
  OsTextImg1,
  OsTextImg2,
  OsTextImg3,
  OsTextImg4,
  OsSectionDesktop16,
  OsSectionTablet16,
  OsSectionMobile16,
  OsSectionDesktop17,
  OsSectionTablet17,
  OsSectionMobile17,
  OsSectionDesktop18,
  OsSectionTablet18,
  OsSectionMobile18,
  OsSectionDesktop19,
  OsSectionTablet19,
  OsSectionMobile19,
  OsSectionDesktop20,
  OsSectionTablet20,
  OsSectionMobile20,
} from '@assets/images/main/os/section';

import { screenViewOs1, screenViewOs2, screenViewOs3, screenViewOs4, screenViewOs5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgDashboardLine } from '@assets/images/icon/svg/dashboard-line.svg';
import { ReactComponent as SvgAppsLine } from '@assets/images/icon/svg/apps-line.svg';
import { ReactComponent as SvgMonitorLine } from '@assets/images/icon/svg/monitor-line.svg';
import { ReactComponent as SvgUsersLine } from '@assets/images/icon/svg/users-line.svg';
import { ReactComponent as SvgBellLine } from '@assets/images/icon/svg/bell-line.svg';

export default {
  bannerData: [
    {
      icon: IconOsServerOn,
      iconInv: IconOsServerOff,
      image: '',
      iconText: 'ORBRO Server',
      sub: 'New',
      link: '/en/os/server',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge RTLS',
      sub: 'New',
      link: '/en/os/rtls',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/en/os/ai',
    },
    {
      icon: IconOsSwitchOn,
      iconInv: IconOsSwitchOff,
      image: '',
      iconText: 'L2 Switch',
      sub: 'New',
      link: '/en/os/switch',
    },
  ],

  title: 'Multi-space and diverse devices,<br/>a digital platform connected at a glance',
  desc: 'With ORBRO OS built into the ORBRO Server, manage spaces, devices, and users on a single screen.<br/>Access real-time data anywhere and ensure secure operations.',

  osLogo: {
    desktop: osLogoDesktop,
    tablet: osLogoTablet,
    mobile: osLogoMobile,
  },

  bannerImg: osBanner,

  screenView: {
    title: 'Integrated Interface for Real-Time Site Monitoring',
    data: [
      { icon: SvgDashboardLine, text: 'Dashboard Home Screen', img: screenViewOs1 },
      { icon: SvgAppsLine, text: 'Widget View Provided', img: screenViewOs2 },
      { icon: SvgMonitorLine, text: 'Supports Multi-Modal View', img: screenViewOs3 },
      { icon: SvgUsersLine, text: 'User Management', img: screenViewOs4 },
      { icon: SvgBellLine, text: 'Notification and Layer Management', img: screenViewOs5 },
    ],
  },
  section: {
    title: 'ORBRO OS runs only on<br/>ORBRO Server and ORBRO Edge.',
    desc: 'Adapted for field scale and conditions: Use ORBRO Edge for small-scale spaces,<br/>and ORBRO Server for large-scale environments to centrally manage spaces, devices, and users.',
    tag: [
      {
        icon: IconPcLine,
        title: 'Reliable 24/7 Operation',
        desc: 'Robust hardware design ensures continuous tasks like location tracking and AI analysis.',
      },
      {
        icon: IconSecurity,
        title: 'Secure Without Cloud',
        desc: 'Sensitive data stays protected within intranet or secure networks, without external cloud transfer.',
      },
      {
        icon: IconLayers,
        title: 'Unlimited Devices & Sensors',
        desc: 'Add wireless tracking tags, sensors, cameras, and more without compromising system stability.',
      },
    ],
    img: {
      desktop: OsSectionDesktop1,
      tablet: OsSectionTablet1,
      mobile: OsSectionMobile1,
    },
  },

  section1: {
    img: OsTextImg1,
    tag: 'Real-time Monitoring',
    title: 'Location, video, and sensors<br/>at a glance in real-time',
    desc: 'Integrated monitoring of IP/PTZ cameras and sensors (temperature, air quality, fire).<br/>Push notifications are sent immediately when anomalies are detected.',
    box: [
      {
        size: 1,
        title: 'Event Alerts & Real-time Location Monitoring',
        desc: 'Monitor building entry and events in real-time. Use RTLS to visualize worker/visitor locations intuitively. Receive alerts instantly upon specific conditions to enhance safety and operational response.',
        img: {
          desktop: OsSectionDesktop2,
          tablet: OsSectionTablet2,
          mobile: OsSectionMobile2,
        },
      },
      {
        size: 2,
        title: 'Live Camera Monitoring',
        desc: 'View real-time video from registered cameras and check camera status, uptime, and connectivity. Troubleshoot issues immediately and utilize ORBRO AI for RTLS tracking and object detection.',
        img: {
          desktop: OsSectionDesktop3,
          tablet: OsSectionTablet3,
          mobile: OsSectionMobile3,
        },
      },
      {
        size: 2,
        title: 'Live Sensor Monitoring',
        desc: 'Air quality sensors collect and analyze temperature, humidity, and fine dust data in real-time. Easily grasp environmental changes via graphs and dashboards, while managing sensor status and locations.',
        img: {
          desktop: OsSectionDesktop4,
          tablet: OsSectionTablet4,
          mobile: OsSectionMobile4,
        },
      },
    ],
  },

  section2: {
    img: OsTextImg2,
    tag: 'Space Management',
    title: 'Digitize your space,<br/>blur the line between virtual and real',
    desc: 'Register building/floor data and place devices to create digital twins of real spaces.<br/>Upload 3D blueprints for more precise virtual environments.',
    box: [
      {
        size: 2,
        title: 'Space Mapping',
        desc: 'Upload floor maps and input scale to generate a digital map matching actual space dimensions. This enables precise area mapping and intuitive placement of devices like cameras and sensors.',
        img: {
          desktop: OsSectionDesktop5,
          tablet: OsSectionTablet5,
          mobile: OsSectionMobile5,
        },
      },
      {
        size: 2,
        title: 'Zone Management',
        desc: 'Define zones on floorplans and track specific objects (people, devices, vehicles). Accumulate and manage data per zone and monitor entry and event logs for better spatial and security operations.',
        img: {
          desktop: OsSectionDesktop6,
          tablet: OsSectionTablet6,
          mobile: OsSectionMobile6,
        },
      },
      {
        size: 1,
        title: '3D Precision Maps',
        desc: 'Upload 3D files for richer spatial information. Accurately visualize structure, floor heights, and installations—helpful for space utilization and safety planning.',
        img: {
          desktop: OsSectionDesktop7,
          tablet: OsSectionTablet7,
          mobile: OsSectionMobile7,
        },
      },
    ],
  },

  section3: {
    img: OsTextImg3,
    tag: 'App Functions',
    title: 'Record, analyze,<br/>and respond automatically',
    desc: 'Record and replay movement paths, visualize trends with Heatmaps,<br/>and automate emergency response with SOP scenarios.',
    box: [
      {
        size: 1,
        title: 'Heatmap',
        desc: 'Visualize foot traffic and visit trends over a selected period based on saved location data. Useful for space planning, safety/security, and marketing insights.',
        img: {
          desktop: OsSectionDesktop8,
          tablet: OsSectionTablet8,
          mobile: OsSectionMobile8,
        },
      },
      {
        size: 1,
        title: 'Record',
        desc: 'Replay recorded location tracking to review movement at specific times. Useful for security, workflow optimization, and facility management.',
        img: {
          desktop: OsSectionDesktop9,
          tablet: OsSectionTablet9,
          mobile: OsSectionMobile9,
        },
      },
      {
        size: 2,
        title: 'SOP Scenario Setup',
        desc: 'Define Standard Operating Procedures triggered by alarms or events. Automate steps including conditions, actions, assignees, and SMS alerts.',
        img: {
          desktop: OsSectionDesktop10,
          tablet: OsSectionTablet10,
          mobile: OsSectionMobile10,
        },
      },
      {
        size: 2,
        title: 'SOP Execution',
        desc: 'When triggered, SOPs provide sequential guidance with location, time, and action details. Share instantly with stakeholders via SMS or other communication tools.',
        img: {
          desktop: OsSectionDesktop11,
          tablet: OsSectionTablet11,
          mobile: OsSectionMobile11,
        },
      },
    ],
  },

  section4: {
    img: OsTextImg4,
    tag: 'Admin Settings',
    title: 'Manage users, groups,<br/>and devices in one place',
    desc: 'Add/edit/delete accounts, groups, cameras, sensors,<br/>and more through an intuitive UI.',
    box: [
      {
        size: 2,
        title: 'User Management',
        desc: 'Easily configure and maintain user types, permissions, and contact details.',
        img: {
          desktop: OsSectionDesktop12,
          tablet: OsSectionTablet12,
          mobile: OsSectionMobile12,
        },
      },
      {
        size: 2,
        title: 'Group Management',
        desc: 'Organize users into teams or departments for structured management.',
        img: {
          desktop: OsSectionDesktop13,
          tablet: OsSectionTablet13,
          mobile: OsSectionMobile13,
        },
      },
      {
        size: 2,
        title: 'Conditional Alerts',
        desc: 'Set custom alerts for events like fire, gas leak, or intrusion. Automatically notify responsible parties with tailored messages.',
        img: {
          desktop: OsSectionDesktop14,
          tablet: OsSectionTablet14,
          mobile: OsSectionMobile14,
        },
      },
      {
        size: 2,
        title: 'Device Management',
        desc: 'Centralized management of all devices—cameras, sensors, tags—with live status, battery, and connectivity info.',
        img: {
          desktop: OsSectionDesktop15,
          tablet: OsSectionTablet15,
          mobile: OsSectionMobile15,
        },
      },
    ],
  },

  section5: {
    img: OsTextImg4,
    tag: '',
    title: 'Wireless, Video, GPS, Access, IIoT—<br/>All in One Platform',
    desc: 'ORBRO OS supports location tracking, access control, and industrial IoT<br/>all within a unified platform. Explore the full lineup.',
    box: [
      {
        size: 1,
        title: 'RF Tracking',
        desc: 'BLE, AoA, UWB-based wireless location tracking',
        img: {
          desktop: OsSectionDesktop16,
          tablet: OsSectionTablet16,
          mobile: OsSectionMobile16,
        },
        link: 'https://orbro.io/en/rtls',
      },
      {
        size: 2,
        title: 'Video Tracking',
        desc: 'AI-powered object tracking through video feeds',
        img: {
          desktop: OsSectionDesktop17,
          tablet: OsSectionTablet17,
          mobile: OsSectionMobile17,
        },
        link: 'https://orbro.io/en/camera',
      },
      {
        size: 2,
        title: 'Outdoor Tracking',
        desc: 'Track vehicles and yards with GPS',
        img: {
          desktop: OsSectionDesktop18,
          tablet: OsSectionTablet18,
          mobile: OsSectionMobile18,
        },
        link: 'https://orbro.io/en/outdoor/gps',
      },
      {
        size: 2,
        title: 'Access System',
        desc: 'Control access via automatic doors, facial recognition, etc.',
        img: {
          desktop: OsSectionDesktop19,
          tablet: OsSectionTablet19,
          mobile: OsSectionMobile19,
        },
        link: 'https://orbro.io/en/access',
      },
      {
        size: 2,
        title: 'IIoT',
        desc: 'Integrate air quality sensors, CO sensors, LoRA gateways, and robots',
        img: {
          desktop: OsSectionDesktop20,
          tablet: OsSectionTablet20,
          mobile: OsSectionMobile20,
        },
        link: 'https://orbro.io/en/iot/LoRAGateway',
      },
    ],
  },

  downloadSection: {
    title: 'Web, Mobile, Tablet—<br/>Operate Securely Anywhere',
    desc: 'ORBRO OS provides the same interface across PC browsers,<br/>iOS/Android apps, and tablets.',
    ios: 'Download for iOS',
    aos: 'Download for Android',
    img: {
      desktop: osDownloadD,
      tablet: osDownloadT,
      mobile: osDownloadM,
    },
  },

  function: {
    title: 'Various Other Features',
    box: [
      {
        icon: IconBlueScan,
        title: 'Real-Time Data Analysis and Visualization',
        desc: 'OS can analyze and visualize collected data, allowing users to understand and utilize collected information in real-time through digital twins.',
      },
      {
        icon: IconBlueShield,
        title: 'Security and Personal Data Protection',
        desc: 'It will provide strong security features to protect digital twins. Limit access to sensitive information and prevent unauthorized modification of data to minimize security issues.',
      },
      {
        icon: IconBlueDevelop,
        title: 'Developer Friendly',
        desc: 'It will be developed to allow developers to easily utilize and extend digital twin functionality. Provide powerful APIs and development tools to develop new applications and services.',
      },
      {
        icon: IconBlueFigure,
        title: 'Integration of Artificial Intelligence',
        desc: 'Integrate artificial intelligence (AI) technology to manage and optimize digital twins more intelligently. Use AI algorithms to analyze data and build predictive models to enhance system performance.',
      },
      {
        icon: IconBluePower,
        title: 'Environmental Monitoring and Intelligent Energy Management',
        desc: 'Integrate environmental monitoring sensors to optimize energy consumption and resource usage. Monitor environmental conditions in real-time and automatically adjust systems as needed to maximize energy efficiency.',
      },
      {
        icon: IconBlueCycle,
        title: 'Automation and Smart Control',
        desc: 'Based on the information collected through digital twins, automated decisions can be made. For example, control devices or execute processes automatically when certain conditions are met.',
      },
      {
        icon: IconBluePlus,
        title: 'Customizable Interface',
        desc: 'It will provide features to customize interfaces according to user needs. Users can freely configure dashboards or applications for monitoring and controlling digital twins.',
      },
      {
        icon: IconBlueCircle,
        title: 'Ecosystem Scalability',
        desc: 'Build an ecosystem where developers and companies can develop their own add-ons or plugins to extend the system. This allows providing customized solutions for various industries and application areas.',
      },
    ],
  },

  faqTitle: 'FAQ',

  beacon: {
    index: 4,
  },
  rtls: {
    index: 1,
  },
  camera: {
    index: 2,
  },
  access: {
    index: 3,
  },
  sensor: {
    index: 4,
  },
  integration: {
    index: 1,
  },
};
